const ORDER_WITH_PENDENCES = "ORDER_WITH_PENDENCES"
const ORDER_REJECTED = "ORDER_REJECTED"
const ORDER_PENDENCE_ACEITE = "ORDER_PENDENCE_ACEITE"
const CARGO_IN_COLETA = "CARGO_IN_COLETA"
const CARGO_IN_TRANSITO = "CARGO_IN_TRANSITO"
const CARGO_SHIP_DELIVERED = "CARGO_SHIP_DELIVERED"
const CADASTRO_VEICULO = "CADASTRO_VEICULO"
export {
    ORDER_WITH_PENDENCES,ORDER_PENDENCE_ACEITE,CARGO_IN_COLETA,CARGO_IN_TRANSITO,CARGO_SHIP_DELIVERED,CADASTRO_VEICULO,ORDER_REJECTED
}